import styled, { css } from 'styled-components';

import {
  overflowStyles,
  sizeStyles,
  spacingStyles,
  StyledOverflowProps,
  StyledSizeProps,
  StyledSpacingProps,
  StyledTextProps,
  textStyles,
} from '../../../../styles';
import { fontSizes, fontWeights, spacing } from '../../../../theme';
import { DataTableVariableNames } from '../../constants';
import { cellTextStyles } from '../DataTableCell/styled';

import { DataTableCellEditorVariableNames } from './constants';

const variableStyles = css({
  [DataTableCellEditorVariableNames.FontWeight]: fontWeights.regular,
  [DataTableCellEditorVariableNames.FontSize]: fontSizes.xs,
});

export const CellEditorRoot = styled.td`
  position: relative;
  box-sizing: border-box;

  ${variableStyles}
`;

export const CellEditorPlaceholder = styled.span<
  StyledSpacingProps & StyledSizeProps & StyledOverflowProps & StyledTextProps
>`
  box-sizing: border-box;
  border-radius: inherit;
  padding: calc(${spacing['8x']} - var(${DataTableVariableNames.BorderWidth}))
    calc(${spacing['12x']} - var(${DataTableVariableNames.BorderWidth}));

  /** placeholder element is visually hidden, but is only there to take cell space so column width doesn't change in auto table layout */
  visibility: hidden;

  ${cellTextStyles}
  font-weight: var(${DataTableCellEditorVariableNames.FontWeight});
  font-size: var(${DataTableCellEditorVariableNames.FontSize});

  ${spacingStyles}
  ${sizeStyles}
  ${overflowStyles}
  ${textStyles}
`;

export const CellEditorOverlay = styled.div`
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  inset: 0;
  border-radius: inherit;
  border: none;

  &:focus-within {
    outline: var(${DataTableVariableNames.ShadowWidth}) solid
      var(${DataTableVariableNames.ShadowColor});

    box-shadow: inset 0 0 0 var(${DataTableVariableNames.OutlineWidth})
      var(${DataTableVariableNames.OutlineColor});
  }
`;
